import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import TabContainer from 'containers/TabContainer/TabContainer';
import ContextStore from 'modules/context';
import { firebaseV8 } from 'modules/firebaseV8';
import ShoppingCart from './ShoppingCart';

const Root = styled('div')(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

function ShoppingCartList() {
  const { setBreadcrumbs, currentUser } = useContext(ContextStore)
  const location = useLocation()
  const [shoppingCart, setShoppingCart] = useState([])

  // const merchandises = Object.keys(shoppingCart).map(i => ({...(shoppingCart[i]), key: i}))
  // issue: when delete doc from shoppingCart, we will get a EMPTY doc like this {key: XXXXXXXXXXX}
  // workaround: filter docs by source field
  const merchandises = Object.keys(shoppingCart).map(i => {
    const maxAmount = (shoppingCart[i]?.purchaseOrders ?
      (Object.keys(shoppingCart[i].purchaseOrders).reduce((acc, cur) => acc - shoppingCart[i].purchaseOrders[cur], shoppingCart[i].amount)) :
      shoppingCart[i]?.amount ?? 0)
    return {
      ...(shoppingCart[i]),
      amount: maxAmount,
      maxAmount,
      key: i
    }
  }).filter(i => i.source)

  const customerMapping = useSelector(state => state.internalVendors.data)

  const customers = [...new Set(merchandises.map(i => i.source))]

  useEffect(() => {
    setBreadcrumbs([{
      text: '採購清單'
    }])
    return () => {
    };
  }, [location.pathname]);

  useEffect(() => {
    const unsubscribe = firebaseV8().collection('shoppingCart').where('user', '==', currentUser.key).onSnapshot(snapshot => {
      const shoppingCart = {}
      snapshot.forEach(doc => {
        shoppingCart[doc.id] = doc.data()
      });
      setShoppingCart(shoppingCart)
    }, err => {})
    return () => unsubscribe()
  }, []);

  const onTabSelected = (tabIndex) => {
  };

  // NEED FIX: 把購物車清空, 會發生 value > tabs.length -1 的情形, 產生一個 error.
  const tabs = customers.map(c => ({
    label: customerMapping[c].nickname,
    component: <ShoppingCart
      source={c}
      ignoreSuppliers={[c]}
      highPrioritySuppliers={customerMapping[c].highPrioritySuppliers || []}
      merchandises={merchandises.filter(i => i.source === c).reduce((acc, cur) => {acc[cur.key] = cur;return acc;}, {})}
    />,
  }))

  return (
    <Root>
      {customers.length ?
        <TabContainer tabs={tabs} onTabSelected={onTabSelected} /> :
        <Box p={2}>
          <Typography variant="h6" id="tableTitle" component="div">
            <FormattedMessage id="shoppingCartList.empty" />
          </Typography>
        </Box>
      }
    </Root>
  );
}

export default ShoppingCartList;
